const __env__ = `prod`,
    __warrantyApi__ = `https://60aqpll7ak.execute-api.us-east-1.amazonaws.com/${__env__}/warranty/check`,
    __key__ = `JwoRNqsOLG5D2djeGip5E7bEpEgcQg0w9olkf5n8`;

async function newFetchReq(obj) {

    if (obj.url != '') {

        try {

            document.querySelector('.warranty-banner-form button').classList.add('button-loading')

            // console.log ( 'fetch stated' );
            const response = await fetch(obj.url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                headers: (obj.headers != undefined ? obj.headers : "{'Content-Type'  :   'application/json'}"),
                body: JSON.stringify(obj.data != undefined ? obj.data : {})
            });

            if (!response.ok) throw await response.json();

            return await response.json();
        }
        catch (err) {
            // console.log ( 'err in generic fetch function' );
            // throw err.message ? err.message : err;

            if (err.message) {
                let message = err.message;
                if(err.message.includes('No data found against email')) {
                    message = 'No data found for the email address entered!'
                }else if (err.message.includes('No data found against machine_number')) {
                    message = 'No data found for the machine number you entered!'
                }else if (err.message.includes('No data found') || err.message.includes('Invalid')){
                    message = 'No data found for the machine number you entered!'
                }else {
                    message = err.message;
                }

                $(`.warranty-banner-form-error`).text(message);
            }

            console.log('API ERROR RESPONSE', err.message);
        } finally {
            document.querySelector('.warranty-banner-form button').classList.remove('button-loading')
        }

    }

}

async function fetchAndManipulate(this_) {
    try {

        const emailOrRef = document.querySelector('.warranty-banner-form input').value;

        const reqObj = {
            url: __warrantyApi__,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': __key__
            },
            data: {}
        };

        if (emailOrRef != '' && emailOrRef.length > 3) {

            if (emailOrRef.includes('@')) {

                reqObj.data.email = emailOrRef.trim();

            } else {

                reqObj.data.machine_number = emailOrRef.trim();

            }

        }

        console.clear();

        // console.log ( 'reqObj', reqObj );

        const getResponse = await newFetchReq(reqObj);

        if (typeof getResponse !== 'undefined' && getResponse.success && typeof getResponse.data !== 'undefined' && getResponse.data) {
            window.localStorage.setItem('warrantyData', JSON.stringify(getResponse.data));
            window.location.href = '/pages/warranty-detail?machine_number=' + getResponse.data[0].machine_number;
        }

    }
    catch (err) {
        console.log(`ERROR fetchAndManipulate`, err.message);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.warranty-banner-form button').addEventListener('click', fetchAndManipulate);

    $(document).ready(function () {

    }).on(`click`, `.warranty-banner-note a`, function (e) {
        try {
            e.preventDefault();
            e.stopImmediatePropagation();
            const getTemplateHTML = $(`template[t="warranty_howToFindRotimaticMachineNumber"]`).html();

            $(`body`)
                .prepend(getTemplateHTML);

        }
        catch (err) {
            console.log(`ERROR .newWarrantyBanner__window--linkWrap a`, err.message);
        }
    }).on(`click`, `.rotimaticMachineNumber .closeModal`, function( e ) {
        try {
      
          e.stopImmediatePropagation();
      
          $( this ).closest( `.rotimaticMachineNumber` ).remove();
      
        }
        catch ( err ) {
          console.log( `ERROR .rotimaticMachineNumber .closeModal`, err.message );
        }
      })
})